import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { cardStyles, Typography } from '../../../ui';

type Props = {
  message: string;
} & HTMLAttributes<HTMLDivElement>;

export function ResourceEmptyState(props: Props) {
  const { message, className, ...rest } = props;

  return (
    <div
      className={twMerge(
        cardStyles({ variant: 'outlined' }),
        'flex items-center justify-center p-32 border-dashed',
        className,
      )}
      {...rest}
    >
      <Typography
        variant="body-xs"
        weight="regular"
        className="text-grayscale300"
      >
        {message}
      </Typography>
    </div>
  );
}
